<template>
  <div class="photoUploader">
    <div class="photoUploader-wrapper">
      <slot></slot>
      <input
        class="photoUploader-input"
        type="file"
        ref="input"
        :accept="accept"
        :disabled="disabled"
        @change="uploader" />
    </div>
  </div>
</template>

<script>
import Exif from 'exif-js'

export default {
  name: 'photoUploader',
  data () {
    return {
      disabled: false,
      isIPhone: false,
      accept: 'image/*'
    }
  },
  created () {
    this.isIPhone = /iphone/gi.test(navigator.userAgent)
  },
  methods: {
    uploader (e) {
      const { files } = e.target
      if (this.disabled || !files.length) {
        return
      }
      this.$toast.loading({
        message: '上传中...',
        duration: 0
      })
      this.getImageData(files[0])
    },
    getImageData (file) {
      /* eslint @typescript-eslint/no-this-alias: 1 */
      // eslint-disable-next-line
      const that = this
      this.readFile(file).then(content => {
        const img = new Image()
        img.onload = function () {
          // 获取图像的数据
          Exif.getData(file, function () {
            const orientation = Exif.getTag(this, 'Orientation') // 获取图像的拍摄方向
            const rotateCanvas = document.createElement('canvas')
            const rotateCtx = rotateCanvas.getContext('2d')
            const imgWidth = img.width / 4
            const imgHeight = img.height / 4

            // 判断机型，ios不处理
            if (that.isIPhone) {
              rotateCanvas.width = imgWidth
              rotateCanvas.height = imgHeight
              rotateCtx.drawImage(img, 0, 0, imgWidth, imgHeight)
            } else {
              rotateCanvas.width = imgWidth
              rotateCanvas.height = imgHeight
              // 针对 Orientation 图像方向进行处理
              switch (orientation) {
                case 1 :
                  rotateCtx.drawImage(img, 0, 0, imgWidth, imgHeight)
                  break
                case 6 : // 顺时针 90 度
                  rotateCtx.translate(0, 0)
                  rotateCtx.rotate(90 * Math.PI / 180)
                  rotateCtx.drawImage(img, 0, -imgHeight, imgWidth, imgHeight)
                  break
                case 8 :
                  rotateCtx.translate(0, 0)
                  rotateCtx.rotate(-90 * Math.PI / 180)
                  rotateCtx.drawImage(img, -imgWidth, 0, imgWidth, imgHeight)
                  break
                case 3 : // 180 度
                  rotateCtx.translate(0, 0)
                  rotateCtx.rotate(Math.PI)
                  rotateCtx.drawImage(img, -imgWidth, -imgHeight, imgWidth, imgHeight)
                  break
                default :
                  rotateCtx.drawImage(img, 0, 0, imgWidth, imgHeight)
              }
            }

            const imgData = rotateCanvas.toDataURL('image/jpeg', 0.5)
            that.$toast && that.$toast.clear()
            that.$emit('afterUploader', imgData)
          })
        }
        img.src = content
      })
    },
    readFile (file) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.onload = event => {
          resolve(event.target.result)
        }
        reader.readAsDataURL(file)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.photoUploader {
  display: inline-block;// 重新制作 需要该样式

  &-wrapper {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
  }

  &-input {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    opacity: 0;
  }
}
</style>
